import { Select, MenuItem, Box, InputLabel, FormControl, FormHelperText } from "@mui/material"
import { useEffect, useState } from "react"
import { Link, useGetIdentity, useTranslate } from "react-admin"
import { CarReadModel } from "../GeneratedClients/FreeBillApi"
import fetchCars from "./fetchCars"

const CarSelect = () => {
  const freeFibuBaseUrl = process.env.REACT_APP_FREE_FIBU_BASE_URL ? process.env.REACT_APP_FREE_FIBU_BASE_URL : 'https://my.freefibu.de/fibu'
  const translate = useTranslate()
  const { data: identity, isLoading: isLoadingIdentity } = useGetIdentity()

  const [cars, setCars] = useState<CarReadModel[]>([])
  const fetchAndSetCars = async() => {
    const cars = await fetchCars(identity!.id.toString())
    setCars(cars??[])
  }

  useEffect(() => {
    fetchAndSetCars()
  }, [])

  if(isLoadingIdentity || !cars || !identity) return null

  return (
    <Box width={"100%"}>
      <FormControl sx={{mt:2, width:"100%"}}>
        <InputLabel>{translate("resources.invoices.carId")}</InputLabel>
        <Select size="small" fullWidth label="lkjlkj">
          {
            cars.map(car => (
              <MenuItem value={car.id}>{car.licensePlate}</MenuItem>
            ))
          }
        </Select>
        <FormHelperText>
          {
            cars && cars.length !== 0 
              ? translate("resources.invoices.dialogs.car")
              : <Link
                  to={`${freeFibuBaseUrl}/kfzVerwaltung`} 
                  target={"_blank"}
                >
                  {translate('ra.action.add')}
                </Link>
          }
        </FormHelperText>
      </FormControl>
    </Box>
  )
}

export default CarSelect